import React, { useState, useEffect, Fragment } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { AppNavBar, setItemActive } from "baseui/app-nav-bar";
import { FaSignOutAlt, FaBuilding, FaUser } from "react-icons/fa";
import { connect } from "react-redux";
import ROUTES_PATH from "../../constants/RouteConstants";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";

import { StyledLink } from "baseui/link";
import logo from '../../../images/templize-logo.svg';
function NavigationBar(props) {
  const [mainItems, setMainItems] = useState(props.items);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    let updatedItems = [...mainItems];

    if (currentPath.includes("modelers") || currentPath.includes("modeler")) {
      updatedItems = setItemActive(updatedItems, updatedItems[1]);
    } else if (
      currentPath.includes("templates") ||
      currentPath.includes("template")
    ) {
      updatedItems = setItemActive(updatedItems, updatedItems[0]);
    } else if (currentPath.includes("marketplace")) {
      // marketplace is commented out, so this won't match any item
      updatedItems = updatedItems.map((item) => ({ ...item, active: false }));
    } else {
      updatedItems = updatedItems.map((item) => ({ ...item, active: false }));
    }

    setMainItems(updatedItems);
  }, [location]);

  async function signOut() {
    try {
      await Auth.signOut();
      history.push("/");
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  function accountMenuItemClick(item) {
    switch (item.key) {
      case "profile":
        history.push(ROUTES_PATH.PROFILE);
        break;
      case "organization":
        history.push(ROUTES_PATH.ORGANIZATION);
        break;
      case "signout":
        signOut();
        break;
      default:
        break;
    }
  }

  return (
    <Fragment>
      <AppNavBar
        mainItems={mainItems}
        overrides={{
          Root: {
            style: ({ $theme }) => ({
              borderBottom: `${$theme.sizing.scale0} solid ${$theme.colors.borderOpaque}`,
              height: "80px", // Set explicit height for navbar
              minHeight: "80px", // Ensure minimum height
            }),
          },
          MainMenuItem: {
            style: ({ $active, $theme }) => {
              if ($active) {
                return {
                  borderBottom: `${$theme.sizing.scale100} solid ${$theme.colors.accent}`, // thick solid line for active item
                  color: $theme.colors.accent, // accent color text for active item
                };
              }
              return {};
            },
          },
          MainMenuItemLabel: {
            component: StyledLink,
            style: ({ $theme }) => ({
              ":hover": {
                color: $theme.colors.accent,
              },
            }),
          },
          AppName: {
            component: () => (
              <Link to="/" style={{ display: "inline-block" }}>
                <img src={logo} alt="App Logo" style={{ height: "60px" }} />
              </Link>
            ),
          },
        }}
        onMainItemSelect={(item) => {
          setMainItems((prev) => setItemActive(prev, item));
          history.push({
            pathname: item.route,
            search: "page=1&time=all",
          });
        }}
        username={props.username}
        userItems={[
          { icon: FaUser, label: "Profile", key: "profile" },
          { icon: FaBuilding, label: "Organization", key: "organization" },
          { icon: FaSignOutAlt, label: "Sign out", key: "signout" },
        ]}
        onUserItemSelect={(item) => accountMenuItemClick(item)}
      />
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    username: state.user.username,
    email: state.user.email,
  };
};

export default connect(mapStateToProps, null)(NavigationBar);
